import i18n from '@whatsmenu/i18n'
export function Footer(props: {
  sideOpen: boolean
  sidebarCompact?: boolean
  haveInvoice: boolean
}) {
  const sidebarWidth = props.sidebarCompact ? 76 : 264
  return (
    <footer
      id="footer "
      className="footer"
      style={{
        marginLeft: props.sideOpen ? `${sidebarWidth}px` : 0,
        width: props.sideOpen ? `calc(100% - ${sidebarWidth}px)` : '100%',
        paddingBottom: props.haveInvoice ? '1rem' : '',
      }}
    >
      <div className="copyright ">
        &copy; Copyright{' '}
        <strong>
          <span>
            <a
              href={
                i18n.language === 'pt-BR'
                  ? 'https://whatsmenu.com.br'
                  : 'https://whatsmenu.pro'
              }
            >
              {i18n.language === 'pt-BR' ? 'WhatsMenu' : 'WhatsMenu.Pro'}
            </a>
          </span>
        </strong>{' '}
        All Rights Reserved
      </div>
      {/* <div className="credits ">
        Designed by <a href="https://grovecompany.com.br/ ">GroveCompany</a>
      </div> */}
    </footer>
  )
}
